// extracted by mini-css-extract-plugin
export default {"whatsappButton":"styles_whatsappButton__7rJWa","whatsappImage":"styles_whatsappImage__sDmzO"};